import { find, set } from "lodash";
import { iUserAttribute } from "@/interfaces/users";

angular.module("app").controller("signupController", signupController);

signupController.$inject = [
  "$scope",
  "$window",
  "BusinessInterestsApi",
  "industries",
  "modalService",
  "UsersApi",
  "userAttrsPayload",
  "thisSiteSettings",
];

function signupController(
  $scope,
  $window,
  BusinessInterestsApi,
  industries,
  modalService,
  UsersApi,
  userAttrsPayload,
  thisSiteSettings,
) {
  const vm = this;

  // properties
  vm.loading = false;
  vm.loadingMessage = "Loading Notice...";
  vm.errors = {};
  vm.dob = new Date();
  vm.form = {
    custom_attrs: {},
    dob: "",
    gender: "f",
    is_subscribed: false,
    title: "Ms",
    industry: undefined,
    interests: [],
  };
  vm.interests = {
    data: [],
  };
  vm.userAttrs = userAttrsPayload;

  // methods
  vm.signup = signup;
  vm.filterBusinessInterests = filterBusinessInterests;

  /**
   * Retrieves interests from the API for the filter control
   *
   * @param {string} search - Search string
   * @return {void}
   */
  function filterBusinessInterests(search: string): void {
    if (search !== "") {
      BusinessInterestsApi.get(
        {
          name: search,
        },
        (response) => {
          vm.interests.data = response.data.map((result) => result.name);
        },
      );
    }
  }

  /**
   * Sign up a new user.
   *
   * @return {void}
   */
  function signup(requestAccess) {
    vm.errors = {};

    if (vm.signupForm.$valid) {
      vm.loading = true;
      vm.loadingMessage = "Awaiting response from user...";

      const modal = modalService.open({
        animation: true,
        templateUrl: "modals/gdpr-modal.html",
        controller: "gdprModal",
        controllerAs: "vm",
        resolve: {
          shouldDeleteUserIfRejected: () => false,
        },
      });

      modal.result.then(
        function (result) {
          vm.loadingMessage = "Signing up as " + vm.form.email + "...";
          var formItems = angular.extend(vm.form, {
            // Convert dates to utc and format
            dob: window.moment(vm.dob).format("Y-MM-DD"),
            // add gdpr info
            agreed_to: result.signup.content,
            agreed_at: window.moment().format("YYYY-MM-DD HH:mm:ss"),
            agreed_on: "signup",
          });

          UsersApi.save(
            formItems,
            function successHander() {
              vm.loading = false;

              if (requestAccess) {
                modalService
                  .open({
                    animation: true,
                    templateUrl: "modals/requested-access.html",
                    controller: "confirmController",
                    controllerAs: "vm",
                    windowClass: "confirm",
                    resolve: {
                      message: function () {
                        return "";
                      },
                    },
                  })
                  .result.then(function () {
                    $window.location = "/";
                  });
              } else {
                if (thisSiteSettings.redirect_new_users_to_plans) {
                  $window.location = "/subscription";
                } else {
                  $window.location = "/";
                }
              }
            },
            function errorHandler(response) {
              vm.loading = false;
              vm.errors = response.data;
            },
          );
        },
        function () {
          vm.loading = false;
        },
      );
    }
  }
}
